import { OfferTransaction } from '@/api';

export function printShippingLabel(transation: OfferTransaction) {
    if (transation.shipping_label_url) {
        window.open(transation.shipping_label_url, '_blank');
        return null;
    }
}
